<template>
  <div>
    <v-layout wrap justify-center>
      <v-flex xs12>
        <Banner />
        <Mapcomponent :mapdata="data1"/>   
        <Gmap/>
        <Screenshots/>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import Banner from "./Banner";
import Gmap from "./Gmap";
   import Mapcomponent from "./mapComponent";
 import Screenshots from "./Screenshots";
 import axios from "axios";
export default {
  components: {
    Banner,
    Gmap,
    Screenshots,
     Mapcomponent,
  },
  data(){
    return{
     data1:[],
    }
  },
  beforeMount(){
this.getData();
  },
  methods:{
    getData(){
      axios({
      method: "GET",
        url: "/dashboard/stats",
      })
      .then((response) =>{
        if(response.data.status)
        {
         this.data1 = response.data.data
        }
         console.log( "data1 is=", this.data1);

      })
    },
   
  }
};
</script>
<style scoped>
#mapnew {
  height: 430px;
  width: 100%;
  margin: 0px;
  padding: 0px;
}
</style>